module.exports = "/lucky-balls/img/regular_game/header_surebet247.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/header_surebet247.png
// module id = 1150
// module chunks = 0